export const landingFaq = [
  {
    question: 'What is GoldAPI.io gold price API?',
    answer: 'GoldAPI.io is a real-time gold price API that provides live and historical gold, silver, platinum, and palladium prices. Developers can access spot prices, bid/ask values, and market data using a fast and reliable JSON API.'
  },
  {
    question: 'Does GoldAPI.io provide live gold and silver prices?',
    answer: 'Yes. GoldAPI.io provides live gold price, silver price, platinum price, and palladium price data across multiple currencies including USD, AUD, EUR, AED, and more. All prices are delivered in real-time via API.'
  },
  {
    question: 'Can I access historical gold price data with GoldAPI.io?',
    answer: 'Yes. GoldAPI.io provides historical gold price data and other precious metals price history through its API. This data can be used for charts, financial analysis, reporting, and backtesting trading strategies.'
  },
  {
    question: 'Which metals and currencies are supported by GoldAPI.io?',
    answer: 'GoldAPI.io supports gold (XAU), silver (XAG), platinum (XPT), and palladium (XPD) prices across multiple currencies such as USD, AUD, CAD, EUR, GBP, AED, SGD, KWD, OMR, and SAR.'
  },
  {
    question: 'Does GoldAPI.io provide currency exchange rates?',
    answer: 'Yes. GoldAPI.io provides current exchange rates between supported currencies through the currency rates API. Select a base and quote currency, such as USD and EUR, to receive the conversion price, bid, ask, and timestamp in a JSON response.'
  },
  {
    question: 'Which historical LBMA fix prices are available?',
    answer: 'GoldAPI.io provides historical LBMA Gold AM prices and Silver daily benchmark prices from 1968, Gold PM prices from April 1968, and Platinum and Palladium AM and PM prices from April 1990. Prices are returned in USD per Troy Ounce, with the preceding available benchmark used for weekends and other non-fixing dates.'
  },
  {
    question: 'Does GoldAPI.io return data in JSON format?',
    answer: 'Yes. GoldAPI.io provides all precious metals price data in JSON format, including spot price, bid, ask, timestamp, daily change, gram price, kilogram price, and other market data fields.'
  },
  {
    question: 'Can I use GoldAPI.io with an AI agent?',
    answer: 'Yes. ChatGPT, Claude, Codex, and other MCP-compatible AI agents can connect to the GoldAPI MCP Server and use structured tools for current and historical metal prices, currency rates, LBMA benchmarks, conversions, valuations, dealer quotes, performance analysis, and portfolio valuation.'
  },
  {
    question: 'What is the GoldAPI MCP Server?',
    answer: 'The GoldAPI MCP Server is a remote Model Context Protocol server that lets ChatGPT, Claude, Codex, and other MCP-compatible AI clients call GoldAPI tools over Streamable HTTP. MCP Server access is included with the Business plan.'
  },
  {
    question: 'How does an AI agent authenticate with the GoldAPI MCP Server?',
    answer: 'The GoldAPI MCP Server supports OAuth for interactive AI clients and the existing GoldAPI key in the x-access-token header for controlled server-side clients. If both are supplied, OAuth authentication takes priority.'
  }
];

export const priceFaq = [
  {
    question: 'How can I get the live {metalName} price in {currencyName} ({metalCode}/{currencyCode})?',
    answer: 'You can get the live {metalName} price in {currencyName} ({metalCode}/{currencyCode}) using GoldAPI.io. The API provides real-time spot prices, bid and ask values, and market data through a fast JSON API.'
  },
  {
    question: 'Does GoldAPI.io provide {metalCode}/{currencyCode} price API in JSON?',
    answer: 'Yes. GoldAPI.io returns {metalCode}/{currencyCode} price data in JSON format, including spot price, bid, ask, timestamp, daily change, and derived values such as gram price and kilogram price.'
  },
  {
    question: 'Can I access historical {metalName} price data for {metalCode}/{currencyCode}?',
    answer: 'Yes. GoldAPI.io provides historical {metalName} price data for {metalCode}/{currencyCode}. You can use this data for charts, analytics, reporting, and financial modeling.'
  },
  {
    question: 'What data fields are included in the {metalCode}/{currencyCode} API response?',
    answer: 'The {metalCode}/{currencyCode} API response includes live spot price, bid, ask, timestamp, daily change, gram price, kilogram price, and other market data depending on the endpoint and plan.'
  }
];

export const blogFaq = [
  {
    question: 'Can I use GoldAPI.io price API examples in production?',
    answer: 'Yes. GoldAPI.io API examples can be used in production applications with your API key. Developers can integrate real-time gold, silver, and precious metals prices into websites, trading platforms, and financial tools.'
  },
  {
    question: 'Does GoldAPI.io support multiple currencies for gold price API?',
    answer: 'Yes. GoldAPI.io supports multiple currencies including USD, AUD, CAD, EUR, GBP, AED, SGD, KWD, OMR, and SAR. You can request gold price and other metals price data in any supported currency.'
  },
  {
    question: 'Is GoldAPI.io suitable for trading bots and financial applications?',
    answer: 'Yes. GoldAPI.io is designed for developers building trading bots, financial dashboards, analytics platforms, and pricing tools. It provides fast and reliable real-time and historical metals price data via JSON API.'
  }
];

export const calculatorFaq = [
  {
    question: 'How does the {metalName} calculator work?',
    answer: 'The calculator estimates {metalName} value using the live {metalCode}/{currencyCode} spot price, weight, purity, quantity, and optional dealer margin.'
  },
  {
    question: 'Can I calculate scrap {metalName} value in {currencyName}?',
    answer: 'Yes. Use the scrap calculator to estimate scrap {metalName} value in {currencyName} based on weight, purity, and live market prices.'
  },
  {
    question: 'Does the calculator support karat purity?',
    answer: 'Yes. The calculator supports common purity levels such as 24K, 22K, 21K, 18K, 14K, 10K, and custom purity percentages.'
  },
  {
    question: 'Can I use GoldAPI.io to build my own {metalName} calculator?',
    answer: 'Yes. Developers can use GoldAPI.io live and historical price data to build calculators, trading tools, dealer pricing systems, and financial applications.'
  }
];
